import { Injectable } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';

/*
  Generated class for the CategoriesProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class CategoriesProvider {
  collection: any;

  constructor(
    private afs: AngularFirestore
  )
  {
    // console.log('Hello CategoriesProvider Provider');
  }


  async getCategories(){
    // console.log("getCategories");
    let data = [];
    if(this.collection== null)
      this.collection = await this.afs.firestore.collection("categories").orderBy('order');
    await this.collection.get().then(querySnapshot => {
      querySnapshot.docs.forEach(doc => {
        let object = doc.data();
        object.id = doc.id;
        data.push(object);
      });
    });
    // console.log("getCategories result",data);
    return data;
  }
}



// WEBPACK FOOTER //
// ./src/providers/categories/categories.provider.ts